<template>
	<div class="login">
		<br />
		<br />
		<br />
		<br />
		<br />
		<br />
		<br />
		<br />
		<transition name="fade" mode="in-out">
			<el-row v-if="!showLoading" class="noCheck">
				<el-col :xs="2" :sm="6" :md="7" :lg="8" :xl="9">
					<h1></h1>
				</el-col>
				<el-col :xs="20" :sm="12" :md="10" :lg="8" :xl="6">
					<el-card shadow="always" style="text-align: center;" :body-style="{padding:'50px'}">
						<el-image style="width: 15%;" src="../img/yuhuiLogo.png" fit="fit"></el-image>
						<h3>闽江师专管理系统</h3>
						<div>
							<el-input placeholder="请输入账号" v-model="inputAcc">
								<template slot="prepend">登录账号</template>
							</el-input>
						</div>
						<br />
						<div>
							<el-input placeholder="请输入密码" v-model="inputPass"  @keyup.enter.native="login()" show-password>
								<template slot="prepend">登录密码</template>
							</el-input>
						</div>
						<br />
						<el-button type="primary" v-if="loginState" style="width: 100%;" @click="login">登录</el-button>
						<el-button type="primary" v-if="!loginState" style="width: 100%;" disabled>登录</el-button>
					</el-card>
				</el-col>
			</el-row>
		</transition>
	</div>
</template>

<script>
	import axios from "../api/index.js"
	import Vue from "../main.js"

	export default {
		name: "Login",
		data() {
			return {
				inputAcc: '',
				inputPass: '',
				loginState: true,
				showLoading: true
			}
		},
		mounted() {
			let self = this;
			let t1 = window.setTimeout(function() {
				self.showLoading = false;
				window.clearTimeout(t1); //去掉定L时器
			}, 1000);
		},
		methods: {
			login: function() {
				let self = this;
				//判断一下账号密码是否为空
				if(this.inputAcc.replace(/\s+/g,"")===""){
					Vue.$message({
						message: "账号不能为空",
						duration: 1000,
						type: "error"
					});
					return;
				}else if(this.inputPass.replace(/\s+/g,"")===""){
					Vue.$message({
						message: "密码不能为空",
						duration: 1000,
						type: "error"
					});
					return;
				}
				// 把按钮改成不能点
				this.loginState = !this.loginState;
				axios.login({
					"acc": this.inputAcc.replace(/\s+/g,""),
					"pass": this.inputPass.replace(/\s+/g,"")
				}).then(res => {
					if (res.data.state === "success") {
						Vue.$message({
							message: "登录成功",
							type: "success",
							duration: 1500
						});
						//验证成功1秒后跳转
						const timer = setInterval(() => {
							// 页面跳转
							Vue.$router.push("/")
						}, 500);
						// 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
						this.$once('hook:beforeDestroy', () => {
							clearInterval(timer);
						})
					} else {
						// 恢復按鈕
						self.loginState = !this.loginState;
						Vue.$message({
							message: "账号或密码错误！	",
							duration: 1300,
							type: "error"
						});
					}
				}).catch(error=>{
					console.log(error);
					// 恢復按鈕
					self.loginState = !this.loginState;
				})
			}
		}
	}
</script>

<style scoped>
	.login {}
</style>
